import { Inject, Injectable, NgZone } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { WINDOW } from "@tylertech/shared-module";
import { Observable, debounceTime, fromEvent } from "rxjs";

@Injectable()
export class TruncateTextService
{
    onResize: Observable<Event>;

    constructor(
        ngZone: NgZone,
        @Inject(WINDOW) window: globalThis.Window)
    {
        this.onResize = ngZone.runOutsideAngular(() =>
            fromEvent(window, "resize")
                .pipe(
                    debounceTime(500),
                    takeUntilDestroyed())
        );
    }
}
